module.exports = __webpack_public_path__ + "static/media/icon_successfully.98c72ce3.png";